import * as React from "react";
import DraggableListItem from "./DraggableListItem";
import {
  DragDropContext,
  Droppable,
  OnDragEndResponder,
  DropResult,
} from "react-beautiful-dnd";
// import { Item } from "../typings";

import { RoutePoint } from "../PublicPage/SidebarPanes/PublicRoutesPane";
import { PropaneSharp } from "@mui/icons-material";

export type DraggableListProps = {
  // TODO use generic type instead of RoutePoint
  items: RoutePoint[];
  //   onDragEnd: OnDragEndResponder;
  setItems: (x: RoutePoint[]) => void;
  handleDeleteItem:(indexToDelete: number) => void;
};

// export type Item = {
//   id: string;
//   primary: string;
//   //   secondary: string;
// };

const DraggableList = React.memo(function DraggableList({
  items,
  setItems,
  handleDeleteItem
}: //   onDragEnd,
DraggableListProps) {
  const reorder = (list: any[], startIndex: number, endIndex: number) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };
  const onDragEnd = ({ destination, source }: DropResult) => {
    // dropped outside the list
    if (!destination) return;

    const newItems = reorder(items, source.index, destination.index);

    setItems(newItems);
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable-list">
        {(provided: any) => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {items.map((item, index) => (
                <DraggableListItem
                  handleDeleteItem={handleDeleteItem}
                  item={item}
                  index={index}
                  key={item.uuid}
                />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
});

export default DraggableList;
